var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 4.90039C7.66863 4.90039 7.40039 5.16863 7.40039 5.5V7.40039H5.5C5.16863 7.40039 4.90039 7.66863 4.90039 8C4.90039 8.33137 5.16863 8.59961 5.5 8.59961H7.40039V10.5C7.40039 10.8314 7.66863 11.0996 8 11.0996C8.33137 11.0996 8.59961 10.8314 8.59961 10.5V8.59961H10.5C10.8314 8.59961 11.0996 8.33137 11.0996 8C11.0996 7.66863 10.8314 7.40039 10.5 7.40039H8.59961V5.5C8.59961 5.16863 8.33137 4.90039 8 4.90039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.9c498258177c35767161a41afc88d669.svg";
export { ForwardRef as ReactComponent };